import { z } from 'zod';

export enum GetFormSetType {
  UserDefined = 'userDefined',
  AutomaticallyApplied = 'automaticallyApplied',
  AutomaticallyAppliedAll = 'automaticallyAppliedAll',
}

export enum FormSetSearchScope {
  CurrentPractice = 'CurrentPractice',
  AcrossEhrSystem = 'AcrossEhrSystem',
}

const baseConfig = z.object({
  formTemplateId: z.string().optional(),
  primitive: z.string().optional(),
});

export const GetFormSetBlockConfigSchema = z.discriminatedUnion('type', [
  baseConfig.extend({
    type: z.literal(GetFormSetType.UserDefined),
    formSetId: z.string(),
  }),
  baseConfig.extend({
    type: z.literal(GetFormSetType.AutomaticallyApplied),
    formSetId: z.string().optional(),
    searchScope: z.nativeEnum(FormSetSearchScope).default(FormSetSearchScope.CurrentPractice),
  }),
  baseConfig.extend({
    type: z.literal(GetFormSetType.AutomaticallyAppliedAll),
    formSetId: z.string().optional(),
    searchScope: z.nativeEnum(FormSetSearchScope).default(FormSetSearchScope.CurrentPractice),
  }),
]);

export type GetFormSetBlockConfig = z.infer<typeof GetFormSetBlockConfigSchema>;
